<template>
  <div class="foot-nav">
    <div class="foot-nav-top">
      <div class="foot-nav-top-min main-con flex flex-vc flex-hb">
        <div class="foot-nav-top-list">
          <div class="foot-nav-top-list-title cur-poi">友情链接</div>
          <div class="foot-nav-top-list-item cur-poi overflow" style="max-width: 100px;" v-for="(item,index) in Blogrolls" :key="index" @click="jumpurl(item.value)">{{item.title}}</div>
        </div>
        <!-- <div class="foot-nav-top-list">
          <div class="foot-nav-top-list-title cur-poi" @click="jump('/')">首页</div>
          <div></div>
        </div>
        <div class="foot-nav-top-list">
          <div class="foot-nav-top-list-title cur-poi" @click="jump('/TCM')">中医类别课程</div>
          <div></div>
        </div>
        <div class="foot-nav-top-list">
          <div class="foot-nav-top-list-title cur-poi" @click="$store.dispatch('user/changeDialog',{isshow:true,type:4})">西医类别课程</div>
          <div></div>
        </div>
        <div class="foot-nav-top-list">
          <div class="foot-nav-top-list-title cur-poi">联系我们</div>
          <div class="foot-nav-top-list-item">电话：{{ aboutinfo.phone }}</div>
          <div class="foot-nav-top-list-item">邮箱：{{ aboutinfo.email }}</div>
        </div> -->
        <div class="foot-nav-top-list-r">
          <img class="list-img" src="@/assets/images/footlogo.png" alt="" />
        </div>
      </div>
    </div>
    <div class="foot-nav-bottom flex flex-hc flex-vc">
      Copyright©2024-2025 信梦时代 版权所有
    </div>
  </div>
</template>

<script>
import {getBlogrolls, getContactUs} from "@/api/postAPI";

export default {
  data() {
    return {
      aboutinfo:'',
      Blogrolls:""
    };
  },
  watch: {},
  mounted() {
    getContactUs({}).then(res => {
      if(res.code == 200) {
        this.aboutinfo = res.data;
      }
    })
    getBlogrolls({}).then(res => {
      if(res.code == 200) {
        this.Blogrolls = res.data;
      }
    })
  },
  methods: {
    jump(path) {
      this.$router.push({ path });
    },
    jumpurl(url){
      window.open(url);
    }
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
    .foot-nav{
      .foot-nav-top{
        .foot-nav-top-min{
          flex-direction: column !important;
          padding: 20px;
          box-sizing: border-box;
          .foot-nav-top-list{
            width: 100%;
            min-height: auto !important;
            padding-top: 10px !important;
            .foot-nav-top-list-title {
              margin-bottom: 5px !important;
            }
            .foot-nav-top-list-item {
              margin-bottom: 0 !important;
            }

          }
        }

      }

    }

}

.foot-nav {

  .foot-nav-top {
    background: #232323;
    .foot-nav-top-list {
      min-height: 130px;
      padding-top: 20px;
      .foot-nav-top-list-title {
        font-weight: bold;
        font-size: 14px;
        color: #ffffff;
        text-align: left;
        margin-bottom: 16px;
      }
      .foot-nav-top-list-item {
        font-weight: 400;
        font-size: 12px;
        color: #ffffff;
        margin-bottom: 12px;

      }
    }
    .foot-nav-top-list-r {
      .list-img {
        width: 128px;
        height: 79px;
      }
    }
  }

  .foot-nav-bottom {
    height: 35px;
    background: #232323;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    text-align: center;
  }
}
</style>
